import React, { Component } from 'react';
import AdvancedRoleMapping from '../advancedRoleMapping'
import classNames from 'classnames';
import styles from './style.scss';


export default class AdvancedRoleMappingList extends Component {

    rowRenderer = (mapping) => { 
        var {translations, ldapRoleMappingsStore} = this.props;         
        return (<AdvancedRoleMapping
                    key={mapping.id}
                    translations={translations}
                    ldapRoleMappingsStore={ldapRoleMappingsStore}
                    mapping={mapping}
                />)
    }
    
    render() {
        return(
            <div className={classNames(styles.advancedRoleMappingsElements)}>
                {
                    this.props.ldapRoleMappings.map((mapping, index) => {
                        return this.rowRenderer(mapping);  
                    })
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/advancedRoleMappings/advancedRoleMappingList/index.jsx